/* global ePayco */

import React, {Component} from 'react';
import {Button, Card, Header} from 'semantic-ui-react';
import PriceCard from "./PriceCard";
import {connect} from "react-redux";
import PlanPopup from "./PlanPopup";
import CustomDivider from "../extras/CustomDivider";
import PaymentData from "../../data/PaymentData";
import {showToast} from "../../actions/ToastAction";

class Prices extends Component {
    constructor(){
        super();
        this.handlePay = this.handlePay.bind(this);
        this.state = {
            loading: false
        }
    }

    handlePay(){
        if(this.props.price.id){
            this.setState({loading:true});
            PaymentData.getPaymentData(this.props.price.id).then(res =>{
                if(res.payment_data){
                    let handler = ePayco.checkout.configure({
                        key: '4ac507fd31cfb800c90768c17631686f',
                        test: false
                    });
                    handler.open(res.payment_data);
                    setTimeout(() => {this.setState({loading:false});}, 5000);
                }else{
                    this.props.showToast({message:'Tenemos un problema!', type:'error'});
                    this.setState({loading:false});
                }

            });
        }else{
            this.props.showToast({message:'Por favor seleccione la cantidad de meses a pagar!', type:'error'});
        }
    };

    back = () => {
        this.setState({loading:false});
        this.props.callbackSelectBack();
    }

    render() {
        return (
            <div>
                <Header
                    as='h2'
                    textAlign='center'
                >
                    Actualiza a
                    <span className={'orange'}> PLAN {this.props.plan.name}
                        <PlanPopup plan={this.props.plan}/>
                    </span>
                    <Header.Subheader>
                        Selecciona una de las opciones
                    </Header.Subheader>
                </Header>
                <Card.Group doubling stackable itemsPerRow={5}>
                    {
                        this.props.plan.prices.map(price => <PriceCard{...price} key={price.id} plan_price={this.props.plan.initial_price}/>)
                    }
                </Card.Group>
                <p>
                    <br/>
                    <Button fluid primary onClick={this.handlePay} loading={this.state.loading} disabled={this.state.loading}>
                        Pagar
                    </Button>
                </p>
                <CustomDivider/>
                <Header textAlign='center'>
                    <Header.Subheader><span style={{cursor:'pointer'}} onClick={() => this.back()}>Seleccionar otro plan</span></Header.Subheader>
                </Header>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        }
    }
}

const mapStateToProps = state => {
    return{
        plan: state.get('plan'),
        price: state.get('price')
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Prices);



// WEBPACK FOOTER //
// ./src/components/settings/Prices.js